import React from 'react';
import css from './Required.module.css';

export const Required = () => <span className={css.required}>*</span>;
